/**
 * 健康习惯版本组件注册表（P0-0.1，P1-1.7 登记 V2）
 *
 * V1 = 原 HealthHabitView，已原样搬迁到 ./legacy，内部逻辑一行未改（D1/D4）。
 * V2 = ./v2，渲染 + 两端点编排（D14）；它只画不判（D12），所以这张表仍是“谁在包里”，不是“谁生效”。
 *
 * 这里登记的组件只负责“渲染”，不得内置阈值与判定逻辑（D12 不变式）——
 * 判据来自 `/healthHabit/v2/profile`，版本开关来自服务端 `/healthHabit/version`（外壳 `versionPolicy`）。
 * 某版本不在包里时外壳自动不显示切换入口，因此 V2 没进包的环上环下都零变化（§7 P0 验收）。
 */
import HealthHabitLegacyView from './legacy';
import HealthHabitV2View from './v2';

const registry = {
  V1: HealthHabitLegacyView,
  V2: HealthHabitV2View,
};

export function getViewComponent(version) {
  return registry[version] || null;
}

export function isVersionBundled(version) {
  return Boolean(getViewComponent(version));
}
